<template>
	<component :is="layout" />
</template>
<script>
  import {$config} from "@/tenants/config";

	export default
	{
		name: 'App',
		data() {
			return {
				layout: null
			}
		},
    watch: {
      $route(to) {
        // ---------------------------------
        // 멀티 테넌트 레이아웃 설정
        // ---------------------------------
        // (1) 레이아웃 설정
        const name = to?.meta?.layout || "User";
        this.layout = $config.getLayout(name);

        // (2) 타이틀 설정
        if (to.meta.title) {
          document.title = to.meta.title
        } else {
          document.title = "Dot Account"
        }

        // (3) favicon 아이콘 설정
        if (to.meta.favicon) {
          const link = document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "icon";
          link.href = to.meta.favicon;
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      }
    },
	}
</script>

<style>
@font-face {
	font-family: 'goudy-old-style';
	src: url('assets/fonts/goudos.woff2') format('woff2');
}

  #app {
    font-family: goudy-old-style, Georgia, serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 0px;
  }
</style>
